import { render, staticRenderFns } from "./publishDialog.vue?vue&type=template&id=47355bcf&scoped=true&lang=pug"
import script from "./publishDialog.vue?vue&type=script&lang=js"
export * from "./publishDialog.vue?vue&type=script&lang=js"
import style0 from "./publishDialog.vue?vue&type=style&index=0&id=47355bcf&prod&lang=scss&scoped=true"
import style1 from "./publishDialog.vue?vue&type=style&index=1&id=47355bcf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47355bcf",
  null
  
)

export default component.exports